import { render, staticRenderFns } from "./Devolutions.vue?vue&type=template&id=3492d0f2"
import script from "./Devolutions.vue?vue&type=script&lang=js"
export * from "./Devolutions.vue?vue&type=script&lang=js"
import style0 from "./Devolutions.vue?vue&type=style&index=0&id=3492d0f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports